<!--
  File: App.vue
-->

<template>
  <v-app>
    <v-app-bar app color="white" class="elevation-0">
      <img v-if="login == null" src="../public/logo.png" width="28px" class="mr-3">
      <v-app-bar-nav-icon v-if="login" @click="drawer = !drawer" />
      <v-toolbar-title class="primary--text">
        BalletFIT Korea<span v-if="login"> - {{title}}</span>
      </v-toolbar-title>
      <v-spacer />
    </v-app-bar>
    <v-navigation-drawer v-model="drawer" app v-if="login">
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title class="title">
            BalletFIT Korea
          </v-list-item-title>
          <v-list-item-subtitle>
            {{subtitle}}
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-divider />
      <v-list dense nav >
        <v-row class="pa-3">
          <v-list-item link :to="'/'">
            <v-list-item-icon>
              <v-icon>mdi-home</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>HOME</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item v-for="menu in menus" :key="menu.title" link :to="menu.to">
            <v-list-item-icon>
              <v-icon>{{ menu.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ menu.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-row>
        <v-divider class="mt-3 mb-3" />
        <v-list-item link :to="'/modify'">
          <v-list-item-icon>
            <v-icon>mdi-account-edit</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>내 정보 수정</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item @click="logout()">
          <v-list-item-icon>
            <v-icon>mdi-account-arrow-right</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>로그아웃</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <v-main>
      <v-divider />
      <v-container fluid>
        <router-view @login="setLogin"/>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: 'App',
  
  data () {
    return {
      login: null,
      title: null,
      subtitle: null,
      drawer: false,
      menus: []
    }
  },

  methods: {
    setLogin: function (login, menus) {
      this.drawer = false
      this.login = login
      if (this.login) {
        if (this.login.level == 5) {
          this.title = this.login.name + ' (' + this.login.studio_name + ')'
          this.subtitle = '스튜디오 운영자 콘솔'
        }
        if (this.login.level == 10) {
          this.title = this.login.name + ' (시스템 관리자)'
          this.subtitle = '시스템 관리자 콘솔'
        }

        if (menus) {
          this.menus = menus
        }
      }
      else {
        this.title = null
      }
    },

    logout: function () {
      if (confirm('정말로 로그아웃 하시겠습니까?')) {
        this.login = null
        localStorage.setItem('login', '')
        this.$router.push('/login')
      }
    }
  },

  created () {
    console.log('App started')
  }
}
</script>
